import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon.jsx';

const { FiPlay } = FiIcons;

const Testimonials = () => {
  // Ordem rigorosa solicitada:
  // 1. Foto (152d9073.jpg)
  // 2. Foto (2d854e60.jpg)
  // 3. Vídeo (XbNKr_zC568)
  // 4. Foto (c94af073.jpg)
  // 5. Foto (24c56d0e.jpg)

  const items = [
    {
      id: "photo-3",
      type: 'image',
      url: 'https://static-media.hotmart.com/lNSNU6cSF6N7XKvOlRvXE8BLUJE=/filters:quality(100)/klickart-prod/uploads/media/file/7456688/imagem_do_whatsapp_de_2024-02-13_(s)_12.39.23_152d9073.jpg'
    },
    {
      id: "photo-4",
      type: 'image',
      url: 'https://static-media.hotmart.com/PlVB23ZaVzi9TOULLAJNLTDJg5E=/filters:quality(100)/klickart-prod/uploads/media/file/7456689/imagem_do_whatsapp_de_2024-02-13_(s)_12.39.27_2d854e60.jpg'
    },
    {
      id: "video-main",
      type: 'video',
      content: 'XbNKr_zC568',
      thumb: 'https://img.youtube.com/vi/XbNKr_zC568/hqdefault.jpg'
    },
    {
      id: "photo-1",
      type: 'image',
      url: 'https://static-media.hotmart.com/KThksqqMmq-6q9gM5rj2SezUdyE=/filters:quality(100)/klickart-prod/uploads/media/file/7456703/imagem_do_whatsapp_de_2024-02-16_(s)_18.44.15_c94af073.jpg'
    },
    {
      id: "photo-2",
      type: 'image',
      url: 'https://static-media.hotmart.com/5iiVeYNzgoeRsHjmR5Geg4s2Cz4=/filters:quality(100)/klickart-prod/uploads/media/file/7456687/imagem_do_whatsapp_de_2024-02-16_(s)_18.44.16_24c56d0e.jpg'
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-[#0e1a30] relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-[#020617] to-transparent z-10"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-[#29ff89] font-bold tracking-widest uppercase text-sm mb-2 block">Histórias Reais</span>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6 uppercase">
            Famílias Transformadas
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Veja os resultados reais de quem aplicou o método.
          </p>
        </motion.div>

        {/* Container Flex para deixar lado a lado */}
        <div className="flex flex-wrap justify-center gap-6 md:gap-8 items-start">
          {items.map((item, index) => (
            <motion.div 
              key={item.id}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`w-full ${item.type === 'video' ? 'max-w-[300px]' : 'max-w-[240px]'} flex-shrink-0`}
            >
              <div className={`bg-white rounded-[2rem] overflow-hidden shadow-2xl border-4 ${item.type === 'video' ? 'border-[#29ff89]' : 'border-gray-700 hover:border-[#29ff89]'} transition-all group`}>
                {item.type === 'video' ? (
                  <div 
                    className="aspect-[9/16] relative flex items-center justify-center bg-black cursor-pointer"
                    onClick={() => window.open(`https://www.youtube.com/watch?v=${item.content}`, '_blank')}
                  >
                    <img src={item.thumb} alt="Vídeo Depoimento" className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-40 transition-opacity" />
                    <div className="relative z-10 bg-[#29ff89] w-14 h-14 rounded-full flex items-center justify-center shadow-[0_0_20px_rgba(41,255,137,0.6)] group-hover:scale-110 transition-transform">
                      <SafeIcon icon={FiPlay} className="w-7 h-7 text-[#0e1a30] ml-1" />
                    </div>
                  </div>
                ) : (
                  <img src={item.url} alt={`Resultado ${item.id}`} className="w-full h-auto object-cover" />
                )}
              </div>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-20">
          <a 
            href="https://pay.kiwify.com.br/IotGhts" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-[#29ff89] text-[#0e1a30] px-12 py-5 rounded-full text-xl font-black hover:bg-white transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(41,255,137,0.4)]"
          >
            QUERO ESSES RESULTADOS
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;